import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'cmi-notification',
  imports: [NgClass],
  templateUrl: './notification.html'
})
export class Notification {
  public readonly mode = input<'info' | 'warning' | 'error' | 'success'>('info');
  public readonly message = input<string | undefined>(undefined);
  public readonly description = input<string | undefined>(undefined);
  public readonly actionLabel = input<string | undefined>(undefined);
  public readonly actionClick = output<void>();
}
